import path from "path"

import { config } from "@lib/config"

export function serverPath(staticFilePath: string): string {
  return path.join(config.data.prefix || "", staticFilePath)
}
